'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:train:selectDateRush');
}

var _invoke = require('../invoke');

/**
 * 选择出行日期
 *
 *
 * 支持版本
 * + iHotel/5.8+
 *
 * @memberof train
 * @static
 * @name selectDateRush
 * @param {Object} opts 选项
 * @return {Promise<date>}
 * @example
 *  hbnb.train.selectDateRush({
 *      date: '2015-10-19',
 *      days: 60,
 *      buyRange: [{
 *          start: '2015-11-11',
 *          finish: '2015-12-11'
 *      }],
 *      reserveRange: [{
 *          start: '2015-12-12',
 *          finish: '2015-12-31'
 *      }]
 *  })
 *      .then(function(date) {
 *          date = '2015-12-13'
 *      });
 */
module.exports = function(opts) {
    if (process.env.NODE_ENV !== 'production') {
        debug('opts is %j', opts);
    }

    var p = new Promise(function(resolve, reject) {
        opts.callback = function(date) {
            resolve(date.date);
        };
        _invoke('train', 'select_date_rush', opts);
    });
    return p;
};




//////////////////
// WEBPACK FOOTER
// ./~/@hfe/hbnb/train/select-date-rush.js
// module id = 317
// module chunks = 0